export default __webpack_public_path__ + "db4a495a8d29958c71f8d91ac79b552b.svg";